"use client";

import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import AttendanceSheet from "../components/attendance/AttendanceSheet";
import api from "../services/api";

const Attendance = () => {
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    setLoading(true);
    try {
      const response = await api.get("/courses");
      const coursesData = response.data.data || [];

      // Fix: Handle case-insensitive status comparison
      const activeCourses = coursesData.filter(
        (course) => course.status?.toLowerCase() === "active"
      );

      setCourses(activeCourses);
    } catch (error) {
      console.error("Error fetching courses:", error);
      toast.error("Failed to load courses");
    } finally {
      setLoading(false);
    }
  };

  const handleCourseChange = (e) => {
    const courseId = e.target.value;
    const course = courses.find((c) => c._id === courseId) || null;
    setSelectedCourse(course);
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-semibold text-gray-800 mb-6">Attendance</h1>

      <div className="space-y-6">
        <div className="form-group">
          <label
            htmlFor="course"
            className="block text-gray-700 font-medium mb-2"
          >
            Select Course
          </label>
          <select
            id="course"
            className="form-control block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
            onChange={handleCourseChange}
            value={selectedCourse?._id || ""}
          >
            <option value="">-- Select a course --</option>
            {courses.length > 0 ? (
              courses.map((course) => (
                <option key={course._id} value={course._id}>
                  {course.name}
                </option>
              ))
            ) : (
              <option disabled>No courses available</option>
            )}
          </select>
        </div>

        <div className="form-group">
          <label
            htmlFor="date"
            className="block text-gray-700 font-medium mb-2"
          >
            Select Date
          </label>
          <input
            type="date"
            id="date"
            className="form-control block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
            value={selectedDate}
            onChange={handleDateChange}
            max={new Date().toISOString().split("T")[0]}
          />
        </div>
      </div>

      {loading ? (
        <div className="loading-spinner text-center py-6 text-xl text-gray-500">
          <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-lg text-gray-600">Loading course...</p>
        </div>
      ) : selectedCourse ? (
        <AttendanceSheet
          course={selectedCourse}
          date={selectedDate}
          canEdit={true}
        />
      ) : (
        <div className="text-center text-gray-500">
          Please select a course to view attendance
        </div>
      )}
    </div>
  );
};

export default Attendance;
